export default __webpack_public_path__ + "images/fdf42ad611a6ca38280eb798555c9391.png";